const rankingItems = [
  {
    rank: 1,
    title: '庆余年第二季',
    heat: '热度 9867',
    category: '古装权谋',
    description: '范闲归来，京都风云再起，朝堂博弈精彩升级',
    highlight: true,
  },
  {
    rank: 2,
    title: '与凤行',
    heat: '热度 9542',
    category: '仙侠爱情',
    description: '碧苍王沈璃与神君行止的三界虐恋',
    highlight: false,
  },
  {
    rank: 3,
    title: '狐妖小红娘月红篇',
    heat: '热度 9315',
    category: '漫改玄幻',
    description: '涂山红红与东方月初跨越种族的爱情传奇',
    highlight: false,
  },
  {
    rank: 4,
    title: '玫瑰的故事',
    heat: '热度 9088',
    category: '都市情感',
    description: '黄亦玫跨越二十年的成长与情感历程',
    highlight: false,
  },
  {
    rank: 5,
    title: '墨雨云间',
    heat: '热度 8876',
    category: '古装悬疑',
    description: '县令之女薛芳菲步步为营的复仇之路',
    highlight: false,
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-14">
          <div className="lg:w-80 flex-shrink-0">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              热播榜单
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mb-4">
              实时热度排行，看看大家都在追什么剧
            </p>
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <i className="ri-fire-fill text-accent-500 text-base"></i>
              <span>数据每30分钟更新</span>
            </div>
          </div>

          <div className="flex-1 space-y-3">
            {rankingItems.map((item) => (
              <a
                key={item.rank}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`flex items-center gap-4 p-4 rounded-lg cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-300/50 ${
                  item.highlight
                    ? 'bg-gradient-to-r from-accent-100 to-accent-50 border border-accent-200'
                    : 'bg-background-100 border border-background-200'
                }`}
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-heading text-lg font-bold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-400 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5">
                    <h3 className="font-heading text-base md:text-lg text-foreground-900 whitespace-nowrap">{item.title}</h3>
                    <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap">{item.category}</span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 line-clamp-1">{item.description}</p>
                </div>
                <div className="flex-shrink-0 text-right">
                  <div className="text-sm font-medium text-accent-600 whitespace-nowrap">{item.heat}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}